import favicon from "../../../../public/favicon.ico"
import logo from "../../../../public/logo/logo.webp"
import logoLine from "../../../../public/logo/logoLine.webp"
import logoLight from "../../../../public/logo/logoLine.webp"
import logo2 from "../../../../public/logo/logo2.webp"

export const DynamicMedia = {
    favicon: favicon,
    logo: logo,
    logo2: logo2,
    logoLine: logoLine,
    mobileLogo: logoLine,
    mobileLogo2: logo2,
    logoLight: logoLight,
}